export default __webpack_public_path__ + "static/Денежный поток 303+404_1-4ec148e88ee4cd6260f3faa936e10bfb.png";